export class WorkFlowUtilities {
  static split_workflow_address(address) {
    const matches = [...address.matchAll(/\d{5}/g)];
    const last_match = matches.pop();
    if (!last_match) return { address: address, postal_code: "" };
    const postal_code = last_match["0"];
    const postal_code_index = last_match.index;
    let clean_address = address.substr(0, postal_code_index) + address.substr(postal_code_index + 5);

    clean_address = clean_address.replace(/[\s\.,]([Cc][\.]*[Pp][\.]*)/, "");
    clean_address = clean_address.replace(/  +/g, " ");

    let clean_address_initial_length = clean_address.length;
    let removed_char = true;
    while (removed_char) {
      clean_address = clean_address.replace(/,$/, "");
      clean_address = clean_address.replace(/\s$/, "");
      if (clean_address_initial_length == clean_address.length) {
        removed_char = false;
      } else {
        removed_char = true;
        clean_address_initial_length = clean_address.length;
      }
    }
    return { address: clean_address, postal_code: postal_code };
  }
}
